import { get } from '@rails/request.js'
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="request-on-select"
export default class extends Controller {
  static targets = ["select"]
  static values = {
    url: String,
  }
  declare readonly selectTarget: HTMLSelectElement
  declare readonly urlValue: string

  request(): void {
    get(this.urlValue, {
      responseKind: 'turbo-stream',
      query: { business_id: this.selectTarget.value },
    })
  }
}
